const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* LaceLinks scroll-trap fix: the product pages' inline body{overflow-x:hidden} forces overflow-y to auto, turning <body> into a nested ~100px scroll container that swallows the wheel. Neutralize it site-wide (higher specificity than body{}, no !important so the cart drawer's inline overflow lock still works; html already clips horizontal overflow so none returns). */
(function () {
  try {
    var s = document.createElement('style');
    s.setAttribute('data-ll-scrollfix', '1');
    s.textContent = 'html body{overflow-x:clip;overflow-y:visible}';
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
})();
